import React, { useState, useEffect, useContext, Component } from 'react';
import { useNavigate, Link, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { authActions } from '../../../redux/store';
import { toast } from 'react-hot-toast';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { Swiper, SwiperSlide } from "swiper/react";
  import LoadingScreen from "../../components/LoadingScreen";

// import required modules
import { FreeMode, Navigation, Thumbs, Pagination } from "swiper/modules";
import axiosInstance from '../../../axiosInstance';
import getDecryptData from '../../../helper/getDecryptData';


const VendorLayout = () => {
const navigate = useNavigate();

      const decryptdatajson = getDecryptData();
      const userId = decryptdatajson?._id;

    const { id } = useParams();

  const stripHtml = (html = "") => html.replace(/<[^>]*>/g, "").trim();

  const [formData, setFormData] = useState({
    userId: userId || "",
    vendorId: id,
    rating: "",
    comment: "",
  });


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };


    const togglePopup = () => {
    setIsOpen(!isOpen);
  };

    const [isOpen, setIsOpen] = useState(false);

      const [Page, setPage] = useState({});
    
  const [loading, setloading] = useState(true);
    const [SubmitRLoading, setSubmitRLoading] = useState(true);


        const [AllCategory, setAllCategory] = useState([]);
  const [AllRating, setAllRating] = useState([]);


        const [isOpenReview, setIsOpenReview] = useState(false);
         


  const getUser = async () => {

 
    setloading(true);

    try {
      const { data } = await axiosInstance.get(`/get-vendor/${id}`);
      setPage(data.Mpage);
          const {success} = data;
        if(!success){
       navigate('/home')
        }
    } catch (error) {
      console.log(error);
      // toast.error("Error fetching Single Blog!");
    } finally {
      setloading(false);
    }
  };

  
      const getcatgeory = async () => {
   
     try {
        const { data } = await axiosInstance.get(`/get-category-product-id?userId=${id}`);
        setAllCategory(data.data);
        console.log('data.categories',data.categories)
      } catch (error) {
        console.error("Error fetching Category:", error);
      }
    };
    

      const getRating = async () => {
    try {
      const { data } = await axiosInstance.get(`/view-vendor-rating/${id}`);
      const productRatings = data.productRatings; // Extract the array from the response
      
      if (productRatings) {
        setAllRating(productRatings); // Set state with the actual reviews
      }
    } catch (error) {
      console.error("Error fetching ratings:", error);
    }
  };



        const AddRating = async () => {
          setSubmitRLoading(false);
      
          if (!userId ) {
            toast.error("Please Login First");
            setSubmitRLoading(true);
      
            return;
          } else {
            if (formData.rating !== "" || formData.comment !== "") {
              try {
                await axiosInstance.post("/add-vendor-rating", formData);
                toggleReviewPopup();
                toast.success("Rating Added successfully!");
                getRating();
              } catch (error) {
                console.error("Error on rating added:", error);
                toast.error(error.response.data.message);
                // setRatings([]);
              } finally {
                setSubmitRLoading(true);
              }
            } else {
              toast.error("Please Fill All Fields");
              setSubmitRLoading(true);
            }
          }
        };
      

          const toggleReviewPopup = () => {
            if (userId) {
              setIsOpenReview(!isOpenReview);
            } else {
              toast.error("Please Login First", );
            }
          };
        


  useEffect(() => {
    getcatgeory();
    getUser();
    getRating();
    window.scrollTo(0, 0);
  }, [id]);

  
const ReviewCard = ({ rating, comment, username, createdAt }) => {
  // Convert the date to a readable format
  const formattedDate = new Date(createdAt).toLocaleDateString();

  // Generate stars based on the rating
  const stars = "★".repeat(rating) + "☆".repeat(5 - rating);

  return (
    <div className="th-review">
      <div className="d-flex align-items-center justify-content-between">
        <div className="fw-semibold">{username}</div>
        <div className="text-secondary small">{formattedDate}</div>
      </div>
      <div className="th-stars">{stars}</div>
      <p className="mb-2">{comment}</p>
      {/* <div className="th-ctrl">
        <button className="btn btn-sm btn-outline-secondary">Helpful</button>
        <button className="btn btn-sm btn-outline-secondary">Comment</button>
        <button className="btn btn-sm btn-outline-secondary">Share</button>
      </div> */}
    </div>
  );
};


  // Calculate the average rating
  const calculateAverageRating = (ratings) => {
    if (ratings.length === 0) return 0;
    const totalRating = ratings.reduce((sum, review) => sum + review.rating, 0);
    return (totalRating / ratings.length).toFixed(1); // Rounded to one decimal point
  };

  const averageRating = calculateAverageRating(AllRating);

  const stars = "★".repeat(Math.floor(averageRating)) + "☆".repeat(5 - Math.floor(averageRating));


    const [enquireData, setEnquireData] = useState([]);
    const [EnquireStatus, setEnquireStatus] = useState(false);
        const [EnquireShow, setEnquireShow] = useState(false);

          const [DataShow, setDataShow] = useState(false);

    
  const enquireToggle = (service) => {
    if (EnquireShow) {
      setEnquireShow(false);
    } else {
      setEnquireShow(true);
         setEnquireData((prevData) => ({
      ...prevData,
      service: service,
    }));
    }
  };

  
  const validate = (email) => {
    // Regular expression to check for invalid characters
    const invalidCharsRegex = /[^\w@_.]| /; // Disallow spaces and any character that's not a word character, @, or .

    // Check for invalid cases
    if (email === "-" || email === "+") {
      return "";
    } else if (invalidCharsRegex.test(email)) {
      return ""; // Return empty string if invalid characters (including spaces) are found
    } else {
      return email; // Return the original email if valid
    }
  };

  const capitalizeEachWord = (str) => {
    if (!str) return str;
    str = str.replace(/\d+/g, "");
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const handleEnquireChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Determine the new value based on input type
    let newValue;
    if (type === "checkbox") {
      newValue = checked;
    } else {
      newValue = value;
    }

    // Capitalize each word for specific fields
    if (name === "fullname") {
      newValue = capitalizeEachWord(newValue);
    }

    if (name === "email") {
      newValue = validate(newValue);
    }

    if (name === "phone") {
      // Replace non-digit characters
      newValue = value.replace(/\D/g, ""); // This allows only digits
      if (newValue.length > 10) {
        newValue = newValue.slice(0, 10); // Limit to 10 digits
      }
    }

    // Update form data with the new value
    setEnquireData((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
  };


    const handleSendEnquire = async () => {
      console.log('enquireData',enquireData)
          setEnquireStatus(true);

      const fields = [
        { name: "fullname", message: "Please enter Full Name" },
        { name: "phone", message: "Please enter phone number" },
        { name: "email", message: "Please enter email" },
      
      ];
  
      for (const field of fields) {
        if (!enquireData[field.name]) {
          toast.error(field.message);
          setEnquireStatus(false);
          return;
        }
      }
  
     const finaldata =  {
      ...enquireData,
      senderId: id,
      userId: decryptdatajson?._id ?? '',
     }

           
      try {
        await toast.promise(axiosInstance.post(`/send-enquire`, finaldata), {
          loading: "Enquire Submiting...", // Loading message
          success: "Enquire Submited Successfully!", // Success message
          error: "Failed to Submit Enquire.", // Error message
        });
        enquireToggle();
        setEnquireData((prevData) => ({
          ...prevData,
          fullname: "",
          email: "",
          phone: "",
          service: "",
          QTY: "",
        })); // Clear form fields
        
        setDataShow(true);
        enquireToggle();

      } catch (error) {
        console.error("Failed to send email:", error);
        // toast.error('Failed to send email');
      } finally {
        setEnquireStatus(false);
      }
    };

      useEffect(() => {
   
    if(decryptdatajson){
    setEnquireData((prevData) => ({
      ...prevData,
      fullname: decryptdatajson.username ?? '',
      phone: decryptdatajson.phone ?? '',
      email: decryptdatajson.email ?? '',
    }));

    }
  }, [decryptdatajson]);


  return (
    <>
      <Header />

      <main className=" bg-light">

    <div
        className="modal enquire fade show"
        style={{ display: EnquireShow ? "block" : "none" }}
        id="exampleModal"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header py-0">
              <h5 className="modal-title" id="exampleModalLabel">
                Enquiry Now
              </h5>
              <button
                type="button"
                className="border-0 close bg-transparent h3"
                data-dismiss="modal"
                aria-label="Close"
                onClick={enquireToggle}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
             
                 {/* Name input */}
                 <div  className="form-outline col-md-12 mb-4">
                  <label className="form-label" htmlFor="form5Example1">
                    Full Name <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="text"
                    name="fullname"
                    id="form5Example1"
                    className="form-control"
                    value={enquireData.fullname}
                    onChange={handleEnquireChange}
                    style={{ boxShadow: "none" }}
                  />
                </div>
                {/* Email input */}
                <div  className="form-outline col-md-6 mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                    Phone No. <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="number"
                    id="form5Example2"
                    className="form-control"
                    name="phone"
                    value={enquireData.phone}
                    onChange={handleEnquireChange}
                    style={{ boxShadow: "none" }}
                  />
                </div>

                <div  className="form-outline col-md-6 mb-4">
                  <label className="form-label" htmlFor="form5Example2">
                    Email address{" "}
                    <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="email"
                    id="form5Example2"
                    className="form-control"
                    name="email"
                    value={enquireData.email}
                    onChange={handleEnquireChange}
                    style={{ boxShadow: "none" }}
                  />
                </div>

           
 

              </div>
            </div>
            <div className="modal-footer">
 
              {/* <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={enquireToggle}
              >
                Close
              </button> */}
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSendEnquire}
                disabled={EnquireStatus} // Properly use the `disabled` attribute
              >
                Submit
              </button>
          
            </div>
          </div>
        </div>
      </div>


{loading ? <LoadingScreen /> :
 <div className="container py-4 page">
  {/* HEADER */}
  <div className="th-card p-3 p-md-4 mb-3">

    <div className="container mb-3 popblock px-0 ">
  <div className="row g-1 "  onClick={togglePopup}  type="button">
    {/* Big left image */}
    <div className="col-md-4">
      <div className=" border-0">
        <img
src={ Page?.gallery[0] ?? ''}
          className="card-img imagecover "
          alt="Photo 1"
          style={{aspectRatio:'1/0.5'}}
          onError={(e) => { e.target.onerror = null; e.target.src = '/assets/img/landscape.png'; }}
        />
      </div>
    </div>

     <div className="col-md-4">
      <div className=" border-0">
        <img
src={ Page?.gallery[1] ?? ''}
          className="card-img imagecover "
          alt="Photo 1"
          style={{aspectRatio:'1/0.5'}}
          onError={(e) => { e.target.onerror = null; e.target.src = '/assets/img/landscape.png'; }}
        />
      </div>
    </div>

    {/* Right-side grid */}
    <div className="col-md-4">
      <div className="row g-1">
        <div className="col-6">
          <img
            src={ Page?.gallery[2] ?? ''} 
            className="img-fluid imagecover"
            alt="Photo 2"
               style={{aspectRatio:'1/0.49'}}
               onError={(e) => { e.target.onerror = null; e.target.src = '/assets/img/landscape.png'; }}
          />
        </div>
        <div className="col-6">
          <img
            src={ Page?.gallery[3] ?? ''} 
            className="img-fluid imagecover"
            alt="Photo 3"
               style={{aspectRatio:'1/0.49'}}
               onError={(e) => { e.target.onerror = null; e.target.src = '/assets/img/landscape.png'; }}
          />
        </div>
        <div className="col-6 position-relative overflow-hidden ">
          <img
            src={ Page?.gallery[4] ?? ''} 
            className="img-fluid imagecover"
            alt="Photo 4"
               style={{aspectRatio:'1/0.49'}}
              onError={(e) => { e.target.onerror = null; e.target.src = '/assets/img/landscape.png'; }}

          />
          
        </div>
        <div className="col-6 position-relative overflow-hidden ">
          <img
            src={ Page?.gallery[5] ?? ''} 
            onError={(e) => { e.target.onerror = null; e.target.src = '/assets/img/landscape.png'; }}
            className="img-fluid imagecover"
            alt="Add More"
               style={{aspectRatio:'1/0.49'}}
          />

           <div className="position-absolute h5 top-0 bg-dark bg-opacity-50 text-white fw-light w-100 h-100 d-flex align-items-center justify-content-center ">
           <div className='text-center fw-bold'> 
                   <svg
            width={40} height={40}
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  xmlnsXlink="http://www.w3.org/1999/xlink"
  x="0px"
  y="0px"
  viewBox="0 0 256 256"
  enableBackground="new 0 0 256 256"
  xmlSpace="preserve"
>
   <g>
    <g>
      <path
        fill="white"
        d="M230.8,38.5V23.2h-12.4v15.2h-15.2v12.4h15.2v15.3h12.4V50.9H246V38.5L230.8,38.5L230.8,38.5z"
      />
      <path
        fill="white"
        d="M205.4,201.9L162.9,78.5l-49.8,102.5l-7.9-0.1l-29.1-36.4l-43,57.3L205.4,201.9z"
      />
      <path
        fill="white"
        d="M55.3,96c0,9.9,8,17.9,17.9,17.9S91,105.9,91,96s-8-17.9-17.9-17.9S55.3,86.1,55.3,96L55.3,96z"
      />
      <path
        fill="white"
        d="M218.7,212.9c0,4.7-3.8,8.5-8.5,8.5H29.9c-4.7,0-8.5-3.8-8.5-8.5V58.1c0-4.7,3.8-8.5,8.5-8.5h149.7V38.3H29.8c-11,0-19.8,8.9-19.8,19.8v154.8c0,11,8.9,19.8,19.8,19.8h180.4c11,0,19.8-8.9,19.8-19.8V90.1h-11.3L218.7,212.9L218.7,212.9z"
      />
    </g>
  </g>
</svg>  <br/>  
             <span className='small'>   +{ Page?.images.length ?? ''}  More Photo </span>
             </div>  
          </div>

        
        </div>
      </div>
    </div>
  </div>
</div>


   {isOpen && (
                <>
                  <div class="propop">
                    <i onClick={togglePopup} class="ri-close-line" type="button" ></i>

                    <Swiper
                      style={{
                        "--swiper-navigation-color": "#335599",
                        "--swiper-pagination-color": "#335599",
                        "padding-bottom": "40px",
                      }}
                      spaceBetween={10}
                      navigation={true}
                      pagination={true}
                      modules={[FreeMode, Navigation, Pagination]}
                      className="mySwiper2 hide-desk-pagenation"
                    >

               {Page?.gallery?.map((imgSrc, index) => (
                                      <SwiperSlide>

  <img
    key={index}
    src={imgSrc ?? '/assets/img/landscape.png'}
    onError={(e) => { e.target.onerror = null; e.target.src = '/assets/img/landscape.png'; }}
    className="w-100 object-fit-contain"
    alt={`Image ${index + 1}`}
    style={{ aspectRatio: '1/1' }}
  />
                        </SwiperSlide>

))}

 
                      {/* {Images.map((imageUrl, index) => (
                        <>
                          <SwiperSlide>
                            <img
                              src={imageUrl}
                              alt="Product Image"
                              className="m-auto d-block"
                            />
                          </SwiperSlide>
                        </>
                      ))} */}
                    </Swiper>
                  </div>
                </>
              )}


    <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3">
      <div>
        <div className="th-header-title mb-1">
         {Page?.username ?? 'anonymous'}
        </div>
        <div className="d-flex flex-wrap align-items-center gap-2">
          <div className="th-rating ps-1">
            <span className="th-rating-badge">{averageRating}</span>
            <span className="small text-success">{stars}</span>
            <span className="text-secondary small"> {AllRating.length}  Ratings</span>
          </div>
   <span className="th-meta">
  {Page?.statename} • Open until 10:00 PM •{' '}
  {Page?.establishment ? `${new Date().getFullYear() - Page.establishment} Years in Business` : ''}
</span>

        </div>
      </div>
      <div className="th-quick-actions d-flex flex-wrap gap-2">
        <button className="btn btn-success" onClick={()=>{enquireToggle(`Vendor: ${ Page.username ?? 'unknown' }`)}} > {DataShow ? Page.phone : 'Show Number'}</button>
        <button className="btn btn-outline-primary">Best Deal</button>
        <a className="btn btn-outline-success" href={DataShow ? `https://api.whatsapp.com/send/?phone=%2B91${Page.whatsapp}` : '#'} >WhatsApp</a>
        {/* <button className="th-icon-btn">❤</button> */}
        {/* <button className="th-icon-btn">⤴</button> */}
        {/* <button className="th-icon-btn">⋯</button> */}
      </div>
    </div>
    {/* Tabs */}
    <ul className="nav nav-pills mt-3 gap-2" role="tablist">
      <li className="nav-item" role="presentation">
        <button
          className="nav-link active"
          data-bs-toggle="pill"
          data-bs-target="#tab-overview"
          aria-selected="true"
          role="tab"
        >
          Overview
        </button>
      </li>
      <li className="nav-item" role="presentation">
        <button
          className="nav-link"
          data-bs-toggle="pill"
          data-bs-target="#tab-products"
          aria-selected="false"
          role="tab"
          tabIndex={-1}
        >
          Products
        </button>
      </li>
      <li className="nav-item" role="presentation">
        <button
          className="nav-link"
          data-bs-toggle="pill"
          data-bs-target="#tab-photos"
          aria-selected="false"
          tabIndex={-1}
          role="tab"
        >
          Photos
        </button>
      </li>
      <li className="nav-item" role="presentation">
        <button
          className="nav-link"
          data-bs-toggle="pill"
          data-bs-target="#tab-quick"
          aria-selected="false"
          tabIndex={-1}
          role="tab"
        >
          Quick Info
        </button>
      </li>
      <li className="nav-item" role="presentation">
        <button
          className="nav-link"
          data-bs-toggle="pill"
          data-bs-target="#tab-reviews"
          aria-selected="false"
          tabIndex={-1}
          role="tab"
        >
          Reviews
        </button>
      </li>
    </ul>
  </div>
  <div className="row g-3">
    {/* MAIN */}
    <div className="col-lg-9">
      {/* Photos */}
      <div className="th-card p-3 p-md-4 mb-3" id="tab-photos" role="tabpanel">
        <div className="d-flex align-items-center justify-content-between mb-3">
          <div className="th-section-title">Photos</div>
          <button className="btn btn-primary btn-sm">
            All Photos
          </button>
        </div>
        <div className="row g-3">

          
         {Page?.images?.map((imgSrc, index) => (
  <div className="col-6 col-md-3" key={index}>
    <div className="th-photo">
      <img
        src={imgSrc ?? '/assets/img/landscape.png'}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = '/assets/img/landscape.png';
        }}
        className="rounded border"
        alt={`Image ${index + 1}`}
      />
    </div>
  </div>
))}


 
        </div>
      </div>


    {/* Similar Businesses */}
      <div className="th-card p-3 p-md-4 mb-3">
      
       <div className="d-flex align-items-center justify-content-between mb-3">
          <div className="th-section-title">Products</div>
          {/* <a className="text-decoration-none" href="#">
            View all →
          </a> */}
        </div>

      <div className="row g-3">
      {/* LEFT: Category list (vertical pills) */}
      <div className="col-lg-3  text-truncate">
        {/* Search UI (no logic) */}
        <div className="input-group mb-3">
          <span className="input-group-text bg-white border-end-0 pe-0 ps-1">🔎</span>
          <input
            type="search"
            className="form-control border-start-0 ps-1 pe-1 shadow-none"
            placeholder="Search "
          />
        </div>

        <div
          className="nav nav-pills flex-column"
          id="service-tabs"
          role="tablist"
          aria-orientation="vertical"
        >
          {AllCategory.map((grp, idx) => {
            const slug = grp?.category?.slug || `cat-${idx}`;
            const title = grp?.category?.title || "Untitled";
            const count = grp?.products?.length ?? 0;
            const isActive = idx === 0 ? "active" : "";
            return (
              <button
                key={slug}
                className={`nav-link d-flex justify-content-between align-items-center ${isActive} rounded-0 text-start`}
                id={`tab-${slug}`}
                data-bs-toggle="pill"
                data-bs-target={`#pane-${slug}`}
                type="button"
                role="tab"
                aria-controls={`pane-${slug}`}
                aria-selected={idx === 0 ? "true" : "false"}
              >
                <span className='small fw-bold d-inline-block text-truncate' style={{maxWidth:100}}>{title}</span>
                <span className="badge text-bg-light">{count}</span>
              </button>
            );
          })}
        </div>
      </div>

      {/* RIGHT: Tab panes / services list */}
      <div className="col-lg-9 ">
        <div className="card">
          {/* <div className="card-body">
            <h4 className="card-title mb-0">List of Services</h4>
          </div> */}
 
          <div className="tab-content" id="service-tabs-content">
            {AllCategory.map((grp, idx) => {
              const slug = grp?.category?.slug || `cat-${idx}`;
              const title = grp?.category?.title || "Untitled";
              const isActive = idx === 0 ? "show active" : "";
              const products = grp?.products || [];
              return (
                <div
                  key={slug}
                  className={`tab-pane fade ${isActive}`}
                  id={`pane-${slug}`}
                  role="tabpanel"
                  aria-labelledby={`tab-${slug}`}
                  tabIndex={0}
                >
                  <div className="px-4 pt-3 py-2">
                    <h5 className="d-flex align-items-center justify-content-between">
                      <span className="fw-semibold small">{title}</span>
                    </h5>
                    <hr />

                    <div className="row g-3">
               
                    {products.map((p, pIdx) => (
                      <>
                       <div className="col-md-4">
 
            <div className=" th-mini-card">
              <Link to={`/product/${p.slug}`} className="th-mini-thumb w-100 mb-2"  > 
                <img src={p.pImage}
                 style={{aspectRatio:'1/1'}}
                 className="rounded object-fit-cover"
                 />
              </Link>
              <div className='col '>
                 <Link to={`/product/${p.slug}`}  className="fw-semibold">  {p?.title || "Service"} </Link>
                <div className="small bg-success d-inline-block px-2 py-1 rounded">4.3 ★</div>
                 <div className="d-flex gap-2 mt-2">
                  <button className="btn btn-sm btn-primary"    onClick={()=>{enquireToggle(`Product: ${p?.title || "Service"}`)}}  >
                    Get Quote
                  </button>
                  <a className="btn btn-sm btn-success" href={DataShow ? `https://api.whatsapp.com/send/?phone=%2B91${Page.whatsapp}` : '#'} >
                    WhatsApp
                  </a>
                </div>
              </div>
            </div>
 
          </div>
          
            <div key={p?._id || pIdx} className={pIdx ? "mt-3 d-none" : "d-none"}>
                        <h5 className="mb-1">{p?.title || "Service"}</h5>

                        {/* Price line */}
                        <div className="mb-2">
                          {typeof p?.salePrice === "number" ? (
                            <>
                              <span className="text-success fw-semibold me-2">
                                ₹{p.salePrice}
                              </span>
                              {typeof p?.regularPrice === "number" && p.regularPrice > p.salePrice && (
                                <small className="text-body-secondary text-decoration-line-through">
                                  ₹{p.regularPrice}
                                </small>
                              )}
                            </>
                          ) : (
                            <a href="#" className="link-primary d-inline-block">Ask for price</a>
                          )}
                        </div>

                        {/* Short description (cleaned) */}
                        {p?.description && (
                          <p className="text-body-secondary">
                            {stripHtml(p.description).slice(0, 200)}
                            {stripHtml(p.description).length > 200 ? "…" : ""}
                          </p>
                        )}

                        <a href="#" className="link-primary d-inline-block mb-3">View More</a>

                        <div className="d-flex gap-2 mb-4">
                          <a href="#" className="btn btn-primary">
                            <span className="me-2">💬</span> Enquire Now
                          </a>
                          <a href={DataShow ? `https://api.whatsapp.com/send/?phone=%2B91${Page.whatsapp}` : '#'}  className="btn btn-outline-success">
                            <span className="me-2" >🟢</span> WhatsApp
                          </a>
                        </div>

                        {pIdx !== products.length - 1 && <hr />}
                      </div>

          </>
                    
                    ))} 
         </div>

                    {!products.length && (
                      <div className="text-body-secondary">No services in this category yet.</div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>

</div>
      {/* Similar Businesses */}
      <div className="th-card p-3 p-md-4 mb-3 d-none">
        <div className="d-flex align-items-center justify-content-between mb-3">
          <div className="th-section-title">Similar Businesses</div>
          <a className="text-decoration-none" href="#">
            View all →
          </a>
        </div>
        <div className="row g-3">
      
 
          <div className="col-md-6">
 
            <div className="d-flex align-items-center gap-3 th-mini-card">
              <div className="th-mini-thumb " style={{width:'30%'}}> 
                <img src="https://images.unsplash.com/photo-1449247709967-d4461a6a6103?q=80&w=600&auto=format&fit=crop"
                 style={{aspectRatio:'1/1'}}
                 className="rounded"
                 />
              </div>
              <div className='col'>
                <div className="fw-semibold">Raydonn Furniture</div>
                <div className="small bg-success d-inline-block px-2 py-1 rounded">4.3 ★</div>
                <p className="text-mute small fw-light mt-2 mb-0"> Loha Mandi, Ghaziabad  </p>
                <div className="d-flex gap-2 mt-1">
                  <button className="btn btn-sm btn-primary"     onClick={enquireToggle} >
                    Get Quote
                  </button>
                  <button className="btn btn-sm btn-success">
                    WhatsApp
                  </button>
                </div>
              </div>
            </div>
 
          </div>
 
    <div className="col-md-6">
 
            <div className="d-flex align-items-center gap-3 th-mini-card">
              <div className="th-mini-thumb " style={{width:'30%'}}> 
                <img src="https://images.unsplash.com/photo-1449247709967-d4461a6a6103?q=80&w=600&auto=format&fit=crop"
                 style={{aspectRatio:'1/1'}}
                 className="rounded"
                 />
              </div>
              <div className='col'>
                <div className="fw-semibold">Raydonn Furniture</div>
                <div className="small bg-success d-inline-block px-2 py-1 rounded">4.3 ★</div>
                <p className="text-mute small fw-light mt-2 mb-0"> Loha Mandi, Ghaziabad  </p>
                <div className="d-flex gap-2 mt-1">
                  <button className="btn btn-sm btn-primary"     onClick={enquireToggle} >
                    Get Quote
                  </button>
                  <a className="btn btn-sm btn-success" href={DataShow ? `https://api.whatsapp.com/send/?phone=%2B91${Page.whatsapp}` : '#'} >
                    WhatsApp
                  </a>
                </div>
              </div>
            </div>
 
          </div>

          
        </div>
      </div>
      {/* Quick Info */}
      <div className="th-card p-3 p-md-4 mb-3" id="tab-quick" role="tabpanel">
        <div className="th-section-title mb-2">Quick Information</div>
                       <div dangerouslySetInnerHTML={{ __html: Page?.about }} className='fw-light' />

        <div className="row g-3">
          <div className="col-sm-6">
            <div className="small text-secondary">Year of Establishment</div>
            <div className="fw-semibold">{Page?.establishment}</div>
          </div>
          <div className="col-sm-6">
            <div className="small text-secondary">Business Type</div>
            <div className="fw-semibold">Manufacturer • Dealer</div>
          </div>
        </div>
      </div>
 

    
      <div className="th-card p-3 p-md-4 mb-3" id="tab-reviews" role="tabpanel">
        <div className="d-flex align-items-center justify-content-between mb-3">
          <div className="th-section-title">Reviews &amp; Ratings</div>
          <span className="text-secondary small">
            {AllRating.length} ratings across the web
          </span>
        </div>
        {/* <div className="d-flex align-items-center gap-3 mb-3">
          <div className="display-6 fw-bold text-success">3.5</div>
          <div>
            <div className="th-stars">★★★★★</div>
            <div className="text-secondary small">Average rating</div>
          </div>
        </div> */}

         <div className="d-flex align-items-center gap-3 mb-3">
        <div className="display-6 fw-bold text-success">{averageRating}</div>
        <div>
          <div className="th-stars">{stars}</div>
          <div className="text-secondary small">Average rating</div>
        </div>
      </div>

        {/* Review composer (mock) */}
        <div className="border rounded p-3 mb-3">
          <div className="mb-2 fw-semibold">Start your review</div>
          <div className="d-flex align-items-center gap-2 th-stars fs-5">
            ☆ ☆ ☆ ☆ ☆
          </div>
          <div className="mt-2">
            <button className="btn btn-primary btn-sm" onClick={toggleReviewPopup}>Post Review</button>
          </div>
        </div>

              {isOpenReview && (
                        <>
                          <div className="custom-popup ">
                            <div className="popup-container ">
                              <button
                                className="btn btn-danger btn-sm d-flex align-items-center justify-content-center"
                                type="button"
                                onClick={toggleReviewPopup}
                              >
                                <i className="ri-close-line" />
                              </button>

                              <div className="card border-0">
                                <div className="card-body border-0">
                                  <h4 className="mb-2">Review And Rating</h4>
                                  <div className="needs-validation">
                                    <div className="mb-4">
                                      <label
                                        className="form-label"
                                        htmlFor="review-rating"
                                      >
                                        How was your experience about our
                                        product?
                                      </label>

                                      <div className="d-flex gap-2 ratingbox">
                                        <input
                                          type="radio"
                                          onChange={handleChange}
                                          name="rating"
                                          id="rating5"
                                          defaultValue="5"
                                          className="d-none"
                                        />
                                        <label htmlFor="rating5">
                                          <i className="ri-star-fill" />{" "}
                                        </label>

                                        <input
                                          type="radio"
                                          onChange={handleChange}
                                          name="rating"
                                          id="rating4"
                                          defaultValue="4"
                                          className="d-none"
                                        />
                                        <label htmlFor="rating4">
                                          <i className="ri-star-fill" />{" "}
                                        </label>

                                        <input
                                          type="radio"
                                          onChange={handleChange}
                                          name="rating"
                                          id="rating3"
                                          defaultValue="3"
                                          className="d-none"
                                        />
                                        <label htmlFor="rating3">
                                          <i className="ri-star-fill" />{" "}
                                        </label>

                                        <input
                                          type="radio"
                                          onChange={handleChange}
                                          name="rating"
                                          id="rating2"
                                          defaultValue="2"
                                          className="d-none"
                                        />
                                        <label htmlFor="rating2">
                                          <i className="ri-star-fill" />{" "}
                                        </label>

                                        <input
                                          type="radio"
                                          onChange={handleChange}
                                          name="rating"
                                          id="rating1"
                                          defaultValue="1"
                                          className="d-none"
                                        />
                                        <label htmlFor="rating1">
                                          <i className="ri-star-fill" />{" "}
                                        </label>
                                      </div>
                                    </div>
                                    <div className="mb-4">
                                      <label
                                        className="form-label"
                                        htmlFor="review-text"
                                      >
                                        Review<span>*</span>
                                      </label>
                                      <textarea
                                        className="form-control"
                                        rows={5}
                                        maxLength={300}
                                        name="comment"
                                        id="review-text"
                                        value={formData.comment}
                                        onChange={handleChange}
                                      />
                                      <div className="invalid-feedback">
                                        Please leave your review.
                                      </div>
                                    </div>

                                    {SubmitRLoading ? (
                                      <button
                                        className="btn btn-primary"
                                        type="button"
                                        onClick={AddRating}
                                      >
                                        Add Review
                                      </button>
                                    ) : (
                                      <button
                                        class="btn btn-secondary btn-sm"
                                        type="button"
                                        disabled
                                      >
                                        <span class="ms-1">Loading...</span>
                                        <span
                                          class="spinner-border spinner-border-sm"
                                          role="status"
                                          aria-hidden="true"
                                        ></span>
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}


        {/* User Reviews */}
        {/* <div className="th-review">
          <div className="d-flex align-items-center justify-content-between">
            <div className="fw-semibold">Vishal Oberoi</div>
            <div className="text-secondary small">26 Dec 2018</div>
          </div>
          <div className="th-stars">★★★★★</div>
          <p className="mb-2">
            Highly appreciated this Company for Garden Jhula, Indoor Swings and
            Hanging Chairs. Specialist in Wooden and Stainless Steel Jhula
            Swings.
          </p>
          <div className="th-ctrl">
            <button className="btn btn-sm btn-outline-secondary">
              Helpful
            </button>
            <button className="btn btn-sm btn-outline-secondary">
              Comment
            </button>
            <button className="btn btn-sm btn-outline-secondary">Share</button>
          </div>
        </div>
        <div className="th-review">
          <div className="d-flex align-items-center justify-content-between">
            <div className="fw-semibold">Ankush</div>
            <div className="text-secondary small">12 Jan 2018</div>
          </div>
          <div className="th-stars">★★★★★</div>
          <p className="mb-2">
            Had good experience at this place whenever we bought Outdoor Swing
            Jhula &amp; Indoor Hanging Chair. Good range, reasonable prices.
          </p>
          <div className="th-ctrl">
            <button className="btn btn-sm btn-outline-secondary">
              Helpful
            </button>
            <button className="btn btn-sm btn-outline-secondary">
              Comment
            </button>
            <button className="btn btn-sm btn-outline-secondary">Share</button>
          </div>
        </div> */}

          {AllRating && AllRating.map((review, index) => (
        <ReviewCard
          key={index}
          rating={review.rating}
          comment={review.comment}
          username={review.username}
          createdAt={review.createdAt}
        />
      ))}

        {/* <div className="text-center mt-3">
          <button className="btn btn-outline-primary">Read all reviews</button>
        </div> */}

      </div>
 


    </div>
    {/* SIDEBAR */}
    <div className="col-lg-3">

       {/* Contact / Sidebar Card (Bootstrap-only) */}
  <div className="th-card p-3 mb-3">
    <div className="card-body">
      <h6 className="card-title mb-3">Contact</h6>
      <div className="d-block">
        <button
          type="button"
          className="btn btn-light border align-items-center justify-content-start d-inline-flex"
        onClick={()=>{enquireToggle(`Vendor: ${ Page.username ?? 'unknown' }`)}}
        >
          <span className="me-2">📞</span>
          <span> {DataShow ? Page.phone : 'Show Number'} </span>
        </button>
      </div>
      <h6 className="mt-4 mb-2">Address</h6>
      <p className="mb-2 small text-body">
        Plot No 13, B. S. International School,
        <br />
        Near Area Vikaspuri, Nilothi–110041
      </p>
      <div className="d-flex align-items-center gap-3 mb-2">
        <a
          href="#"
          className="btn btn-link p-0 d-inline-flex align-items-center"
        >
          <span className="me-2">🗺️</span> Get Directions
        </a>
        <a
          href="#"
          className="btn btn-link p-0 d-inline-flex align-items-center"
        >
          <span className="me-2">📋</span> Copy
        </a>
      </div>
      <ul className="list-group list-group-flush mt-3">
        <li className="list-group-item px-0 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <span className="me-2">🕒</span>
            <span>
              <span className="text-success fw-semibold">Open</span> until 10:00
              pm
            </span>
          </div>
          <span className="text-muted">▾</span>
        </li>
        {/* <li className="list-group-item px-0 d-flex align-items-center">
          <span className="me-2">🖊️</span>
          <a href="#" className="text-decoration-none">
            Suggest New Timings
          </a>
        </li> */}
        {/* <li className="list-group-item px-0 d-flex align-items-center">
          <span className="me-2">✉️</span>
          <a href="#" className="text-decoration-none">
            Send Enquiry by Email
          </a>
        </li>
        <li className="list-group-item px-0 d-flex align-items-center">
          <span className="me-2">📨</span>
          <a href="#" className="text-decoration-none">
            Get info via SMS/Email
          </a>
        </li> */}
        <li className="list-group-item px-0 d-flex align-items-center">
          <span className="me-2">🔗</span>
          <a href="#" className="text-decoration-none">
            Share
          </a>
        </li>
        <li className="list-group-item px-0 d-flex align-items-center">
          <span className="me-2">⭐</span>
          <a href="#" className="text-decoration-none">
            Tap to rate
          </a>
        </li>
        {/* <li className="list-group-item px-0 d-flex align-items-center">
          <span className="me-2">✏️</span>
          <a href="#" className="text-decoration-none">
            Edit this Listing
          </a>
        </li> */}
        {/* <li className="list-group-item px-0 d-flex align-items-center">
          <span className="me-2">🏷️</span>
          <a href="#" className="text-decoration-none">
            Claim this business
          </a>
        </li> */}
        {/* <li className="list-group-item px-0 d-flex align-items-center">
          <span className="me-2">🌐</span>
          <a href="#" className="text-decoration-none">
            Visit our Website
          </a>
        </li> */}
      </ul>
    </div>
  </div>

   


      <div className="th-card p-3 p-md-4 mb-3">
        <div className="th-section-title">Also listed in</div>
        <div className="d-flex flex-wrap gap-2 mt-2">
          <span className="th-pill">Toy Dealers</span>
          <span className="th-pill">Swing Dealers</span>
          <span className="th-pill">Playground Dealers</span>
          <span className="th-pill">Manufacturers</span>
          <span className="th-pill">Wooden Swings</span>
        </div>
      </div>
      
    </div>
  </div>

</div>

}
    

 
    


      </main>

{!loading && 
   <div className="th-card p-2 mt-3 d-flex flex-wrap gap-2 align-items-center justify-content-between bg-white border-top" id="sticky-vendor">
    <div className="small">
      {Page?.username ?? 'anonymous'}
    </div>
    <div className="d-flex gap-2">
      <button className="btn btn-success btn-sm"   onClick={()=>{enquireToggle(`Vendor: ${ Page.username ?? 'unknown' }`)}} > {DataShow ? Page.phone : 'Show Number'} </button>
      <button className="btn btn-outline-primary btn-sm"  onClick={()=>{enquireToggle(`Vendor: ${ Page.username ?? 'unknown' }`)}} >Enquire Now</button>
      <a className="btn btn-outline-success btn-sm" href={DataShow ? `https://api.whatsapp.com/send/?phone=%2B91${Page.whatsapp}` : '#'}>WhatsApp</a>
    </div>
  </div>

}

      <Footer />
    </>

  );
};

export default VendorLayout